import React, { Component } from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import PhoneInput from 'react-phone-number-input';

import ValidationError from '../ValidationError/ValidationError';

import css from './FieldPhoneNumberWithCountryInput.module.css';

const US_COUNTRIES = ['US'];

const HiddenCountrySelectArrow = () => null;

const FieldPhoneNumberWithCountryInputComponent = props => {
  const {
    rootClassName,
    className,
    inputRootClass,
    customErrorText,
    id,
    label,
    input,
    meta,
    onUnmount,
    isUncontrolled,
    inputRef,
    hideErrorMessage,
    defaultCountry,
    countries,
    international,
    withCountryCallingCode,
    ...rest
  } = props;

  if (label && !id) {
    throw new Error('id required when a label is given');
  }

  const { valid, invalid, touched, error } = meta;
  const errorText = customErrorText || error;
  const hasError = !!customErrorText || !!(touched && invalid && error);
  const fieldMeta = { touched: hasError, error: errorText };

  const inputClasses =
    inputRootClass ||
    classNames(css.input, {
      [css.inputSuccess]: valid,
      [css.inputError]: hasError,
    });

  const classes = classNames(rootClassName || css.root, className);

  const phoneInputProps = {
    className: inputClasses,
    id,
    ...rest,
    ...input,
    defaultCountry: defaultCountry || 'US',
    countries: countries || US_COUNTRIES,
    addInternationalOption: false,
    countryCallingCodeEditable: false,
    smartCaret: false,
    international: international !== false,
    withCountryCallingCode: withCountryCallingCode !== false,
    countrySelectProps: { disabled: true, tabIndex: -1 },
    arrowComponent: HiddenCountrySelectArrow,
    value: input.value || undefined,
    onChange: value => input.onChange(value || ''),
  };

  if (isUncontrolled) {
    phoneInputProps.defaultValue = input.value;
    delete phoneInputProps.value;
  }

  if (inputRef) {
    phoneInputProps.ref = inputRef;
  }

  return (
    <div className={classes}>
      {label ? <label htmlFor={id}>{label}</label> : null}
      <PhoneInput {...phoneInputProps} />
      {hideErrorMessage ? null : <ValidationError fieldMeta={fieldMeta} />}
    </div>
  );
};

/**
 * Final Form phone field using react-phone-number-input.
 * This marketplace only accepts US numbers, so the country control is locked.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className]
 * @param {string} [props.rootClassName]
 * @param {string} [props.inputRootClass]
 * @param {string} props.name
 * @param {string} props.id
 * @param {string} [props.label]
 * @param {Function} [props.onUnmount]
 * @returns {JSX.Element}
 */
class FieldPhoneNumberWithCountryInput extends Component {
  componentWillUnmount() {
    if (this.props.onUnmount) {
      this.props.onUnmount();
    }
  }

  render() {
    return <Field component={FieldPhoneNumberWithCountryInputComponent} {...this.props} />;
  }
}

export default FieldPhoneNumberWithCountryInput;
